import React from "react"
import { postSocial, postSocialText, button } from "./social-panel.module.scss"
import {
  FacebookShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
  LinkedinIcon,
} from "react-share"
import PropTypes from "prop-types"

const SocialPanel = ({ postData, location }) => {
  return (
    <div className={postSocial}>
      <p className={postSocialText}>Partagez sur :</p>
      <FacebookShareButton
        url={location}
        className={button}
        title={postData.title}
      >
        <FacebookIcon size={30} round={true} />
      </FacebookShareButton>
      <TwitterShareButton
        url={location}
        className={button}
        title={postData.title}
      >
        <TwitterIcon size={32} round={true} />
      </TwitterShareButton>
      <WhatsappShareButton
        url={location}
        className={button}
        title={postData.title}
      >
        <WhatsappIcon size={32} round={true} />
      </WhatsappShareButton>

      <LinkedinShareButton
        url={location}
        className={button}
        title={postData.title}
      >
        <LinkedinIcon size={32} round={true} />
      </LinkedinShareButton>
    </div>
  )
}

SocialPanel.propTypes = {
  postData: PropTypes.object.isRequired,
  location: PropTypes.object,
}

export default SocialPanel
